export default {
    autoBind: {
        type: Boolean,
        default: undefined
    }, 
    connectionDefaults: {
        type: Object,
        default: undefined
    }, 
    connections: {
        type: Array,
        default: undefined
    }, 
    connectionsDataSource: {
        type: [Object, Array],
        default: undefined
    }, 
    connectionsDataSourceRef: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    }, 
    editable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    layout: {
        type: Object,
        default: undefined
    }, 
    pannable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    pdf: {
        type: Object,
        default: undefined
    }, 
    selectable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    shapeDefaults: {
        type: Object,
        default: undefined
    }, 
    shapes: {
        type: Array,
        default: undefined
    }, 
    template: {
        type: [String, Function],
        default: undefined
    }, 
    theme: {
        type: String,
        default: undefined
    }, 
    zoom: {
        type: Number,
        default: undefined
    }, 
    zoomMax: {
        type: Number,
        default: undefined
    }, 
    zoomMin: {
        type: Number,
        default: undefined
    }, 
    zoomRate: {
        type: Number,
        default: undefined
    },

    // Events
    add: {
        type: Function,
        default: undefined
    },  
    cancel: {
        type: Function,
        default: undefined
    },  
    change: {
        type: Function,
        default: undefined
    },  
    click: {
        type: Function,
        default: undefined
    },  
    dataBound: {
        type: Function,
        default: undefined
    },  
    drag: {
        type: Function,
        default: undefined
    },  
    dragEnd: {
        type: Function,
        default: undefined
    },  
    dragStart: {
        type: Function,
        default: undefined
    },  
    edit: {
        type: Function,
        default: undefined
    },  
    itemBoundsChange: {
        type: Function,
        default: undefined
    },  
    itemRotate: {
        type: Function,
        default: undefined
    },  
    mouseEnter: {
        type: Function,
        default: undefined
    },  
    mouseLeave: {
        type: Function,
        default: undefined
    },  
    pan: {
        type: Function,
        default: undefined
    },  
    remove: {
        type: Function,
        default: undefined
    },  
    save: {
        type: Function,
        default: undefined
    },  
    select: {
        type: Function,
        default: undefined
    },  
    toolBarClick: {
        type: Function,
        default: undefined
    },  
    zoomEnd: {
        type: Function,
        default: undefined
    },  
    zoomStart: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-diagram-vue-wrapper/src/KendoDiagram/DiagramProps.js